import { createFilter, deleteFilter, getFilters, updateFilter } from "../../api/favFilters";
import _ from "lodash";

const favFilters = {
    namespaced: true,
    state: {
        filters: {},
    },
    mutations: {
        SET_FILTERS: (state, filters) => {
            state.filters = filters;
        },
    },
    getters: {
        customChatFilters: (state, getters, rootState) => {
            let filters = state.filters["page.chat-list"] || [];
            const userId = rootState.auth.user?._id;
            filters = filters.filter((filter) => filter.visibility === "public" || filter.user === userId);
            return filters;
        },
    },
    actions: {
        getFilters({ state }, key) {
            return state.filters[key] || [];
        },
        createFilter({ state, commit }, { key, name, filters }) {
            return createFilter(key, name, filters).then((res) => {
                let groupedFilters = { ...state.filters };
                groupedFilters[key] = [...(groupedFilters[key] || []), res.data];
                commit("SET_FILTERS", groupedFilters);
                return res.data;
            });
        },
        updateFilter({ state, commit }, { id, key, icon, name, filters }) {
            return updateFilter(id, icon, name, filters).then((res) => {
                let groupedFilters = { ...state.filters };
                groupedFilters[key] = (groupedFilters[key] || []).map((filter) => {
                    if (filter._id === id) filter = res.data;
                    return filter;
                });
                commit("SET_FILTERS", groupedFilters);
                return res.data;
            });
        },
        async fetchFilters({ commit, state }, key) {
            let filters = state.filters[key];
            if (!filters) {
                filters = await getFilters(key).then((_filters) => {
                    const newFilters = { ...state.filters };
                    newFilters[key] = _filters;
                    commit("SET_FILTERS", newFilters);
                });
            }
            return filters;
        },
        async syncFilters({ commit, state }, key) {
            return await getFilters(key).then((_filters) => {
                const newFilters = { ...state.filters };
                newFilters[key] = _filters;
                commit("SET_FILTERS", newFilters);
                return newFilters;
            });
        },
        deleteFilter({ commit, state }, { id, key }) {
            return deleteFilter(id).then(() => {
                let groupedFilters = { ...state.filters };
                groupedFilters[key] = (groupedFilters[key] || []).filter((f) => f._id !== id);
                commit("SET_FILTERS", groupedFilters);
            });
        },
    },
};

export default favFilters;
